import { DANGER_300, DANGER_500, DANGER_700, INFO_300, INFO_500, INFO_700, PRI_100, PRI_500, PRI_900, SUCCESS_300, SUCCESS_500, SUCCESS_700 } from "./colors";

const pallete = {
  // background: {
  //     default: "#EDEDED",
  // },
  primary: {
    light: PRI_100,
    main: PRI_500,
    dark: PRI_900,
    contrastText: "#FFF",
  },
  error: {
    main: DANGER_500,
    light: DANGER_300,
    dark: DANGER_700,
    contrastText: "#FFF",
  },
  success: {
    main: SUCCESS_500,
    light: SUCCESS_300,
    dark: SUCCESS_700,
    contrastText: "#FFF",
  },
  info: {
    main: INFO_500,
    light: INFO_300,
    dark: INFO_700,
    contrastText: "#FFF",
  },
};

export default pallete;
